import React from 'react';

const GreenTeaIcon: React.FC<{ className?: string }> = ({ className }) => (
  <svg className={className} viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <radialGradient id="greentea-bg" cx="50%" cy="50%" r="50%">
        <stop offset="0%" stopColor="#bbf7d0" />
        <stop offset="100%" stopColor="#f0fdf4" />
      </radialGradient>
      <linearGradient id="greentea-glass" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0%" stopColor="#4ade80" />
        <stop offset="100%" stopColor="#166534" />
      </linearGradient>
    </defs>
    <ellipse cx="32" cy="54" rx="18" ry="6" fill="#166534" opacity="0.18" />
    <circle cx="32" cy="24" r="20" fill="url(#greentea-bg)" opacity="0.18" />
    <rect
      x="20"
      y="10"
      width="24"
      height="36"
      rx="12"
      fill="url(#greentea-glass)"
      stroke="#fff"
      strokeWidth="2"
    />
    <rect x="24" y="14" width="16" height="28" rx="8" fill="#bbf7d0" opacity="0.7" />
    <ellipse cx="32" cy="10" rx="12" ry="4" fill="#bbf7d0" />
  </svg>
);

export default GreenTeaIcon;
